<template>
  <div>
    <span @click="goBack" class="back">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"
    width="18px" height="18px"
    ><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/>
    </svg>
    </span>
    <page-header title="Delivery Addresses" breadcrumb="Dashboard > CRM > Customer Profile > Delivery Addresses" />
    <div class="card pt-5">
      <div class="delivery-address">
        <!-- <div class=" pb-4">
          <p class="text-deepBlue font-semibold">Delivery Addresses</p>
        </div> -->
        <div class="table-wrapper">
          <table class="address-table">
            <thead>
              <tr>
                <th>Default</th>
                <th>Phone</th>
                <th>Country</th>
                <th>Address</th>
                <th>State</th>
                <th>City</th>
                <th>Zip/Postal Code</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(address, index) in deliveryAddresses" :key="index">
                <td class="radio-td">
                  <!-- <input type="radio" /> -->
                  <radio-input :id="`default-address${index}`" :value="true" label=""
                    v-model="address.isDefaultAddress" />
                </td>
                <td>
                  <input type="text" class="input" v-model="address.phone" />
                </td>
                <td>
                  <el-select v-model="address.country" placeholder="Select country">
                    <el-option v-for="country in countries" :key="country" :label="country" :value="country">
                    </el-option>
                  </el-select>
                </td>
                <td>
                  <vue-google-autocomplete id="map2" ref="shipperAddress" :value="address.location"
                    classname="input" placeholder="Enter address" v-on:placechanged="getAddress($event, index)">
                  </vue-google-autocomplete>
                </td>
                <td>
                  <el-select v-model="address.state" placeholder="Select state"
                    @change="getCitiesInState(address.state, index)">
                    <el-option v-for="state in states" :key="state.name" :label="state.name" :value="state.name">
                    </el-option>
                  </el-select>
                </td>

                <td>
                  <el-select v-model="address.city" placeholder="Select city">
                    <el-option v-for="city in address.cities" :key="city" :label="city" :value="city">
                    </el-option>
                  </el-select>
                </td>
                <td>
                  <input type="text" class="input" v-model="address.zipCode" />
                </td>
                <td class="address-action font-semibold text-deepBlue cursor-pointer" @click="removeAddress(index)">
                  <span v-if="deliveryAddresses.length > 1">Remove</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="flex items-center cursor-pointer py-4" @click="addDeliveryAddress">
          <span><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M8.99991 0C4.02947 0 0 4.02953 0 8.99997C0 13.9702 4.02941 18.0001 8.99979 18.0001C13.9702 18.0001 18 13.9702 18 8.99997C18 4.02953 13.9702 0 8.99991 0ZM12.7968 9.99003H9.90057V13.0182C9.90039 13.5259 9.48879 13.9375 8.98089 13.9375C8.47281 13.9375 8.06121 13.5259 8.06121 13.0179V9.99003H5.24212C4.73416 9.98985 4.32275 9.57825 4.32245 9.07035C4.32245 8.56257 4.73422 8.15079 5.24212 8.15067L8.06115 8.15085V5.4634C8.06115 4.95544 8.47293 4.54372 8.98071 4.54372C9.48879 4.54372 9.90057 4.9555 9.90039 5.4634L9.90057 8.15061L12.7965 8.15091C13.3044 8.15061 13.7163 8.56251 13.7161 9.07059C13.7163 9.57855 13.3044 9.99003 12.7968 9.99003Z"
                fill="#10233E" />
            </svg>
          </span>
          <span class="pl-2 font-semibold cursor-pointer text-deepBlue">Add Delivery Address</span>
        </div>

        <div class="py-8">
          <primary-button buttonText="Apply Changes" :loading="loading" @click="updateContact" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueGoogleAutocomplete from "vue-google-autocomplete";
import PageHeader from "@/components/UI/NewPageHeader";
import Vue from "vue";

export default {
  components: {
    PageHeader,
    VueGoogleAutocomplete
  },
  data() {
    return {
      deliveryAddresses: [
        {
          location: {
            lat: "",
            lng: "",
            name: ""
          },
          country: "",
          state: "",
          city: "",
          zipCode: "",
          isDefaultAddress: false,
        },
      ],
      countries: ["Nigeria"],
      states: [],
      cities: [],
      loading: false,
      contactId: null,
    };
  },
  mounted() {
    this.getCustomerInformation();
    this.getAllStatesAndCities();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getAddress(addressData, index) {
      this.deliveryAddresses[index].location.name = addressData.route
      this.deliveryAddresses[index].location.lat = addressData.latitude;
      this.deliveryAddresses[index].location.lng = addressData.longitude;
      // this.shipper.country = addressData.country;
    },
    async getCustomerInformation() {
      this.loading = true;
      const customerId = localStorage.getItem("customerId");
      if (!customerId) {
        this.$router.push({ name: "CRM" });
      }
      try {
        const response = await this.$_getSingleContact(customerId);
        console.log(response);
        this.contactId = response.data.contact.id;
        this.deliveryAddresses =
          response.data.contact.deliveryAddress ?? this.deliveryAddresses;
        this.deliveryAddresses.forEach((address, index) => {
          // address.cities = [];
          Vue.set(address, "cities", []);
          // console.log("fetching cities");
          this.getCitiesInState(address.state, index);
          // console.log(address);
        });
      } catch (error) {
        this.handleError(error);
      }
      this.loading = false;
    },
    async updateContact() {
      this.loading = true;
      this.deliveryAddresses.forEach((address) => {
        delete address.cities;
      });
      let orgId = localStorage.getItem("organizationId");
      const payload = {
        userInfo: {
          orgId: orgId,
          outletId: null,
          creatorId: orgId,
        },
        payload: {
          deliveryAddress: this.deliveryAddresses,
        },
      };
      try {
        const response = await this.$_updateContact(this.contactId, payload);
        this.logResponse(response);
        this.generateToast("Address updated successfully!", "success");
        this.$router.push({ name: "CustomerProfile" });
      } catch (error) {
        this.handleError(error);
      }
      this.loading = true;
    },
    async getAllStates() {
      try {
        let response = await this.$_getAllStates();
        console.log(response);
        this.states = response.data.findState;
      } catch (error) {
        this.handleError(error);
      }
    },
    getCitiesInState(state, index) {
      // let formattedStateName = state
      //   .replace(/\s/g, "")
      //   .replace("State", "")
      //   .toLowerCase();
      this.getCities(state, index);
    },
    async getCities(stateName, index = 1) {
      // this.cities = [];
      try {
        this.cities = [];
        if (stateName?.length > 0) {
          this.deliveryAddresses[index].cities = [...this.states.find(state => state.name == stateName).cities]
        }
        // let response = await this.$_getCities(stateName);
        // this.deliveryAddresses[index].cities = response.data.allCities;
      } catch (error) {
        this.handleError(error);
      }
    },
    addDeliveryAddress() {
      let newDeliveryAddress = {
        location: {
          lat: "",
          lng: "",
          name: ""
        },
        country: "",
        state: "",
        city: "",
        zipCode: "",
        cities: [],
      };
      this.deliveryAddresses.push(newDeliveryAddress);
    },
    removeAddress(index) {
      this.deliveryAddresses.splice(index, 1);
    },
  },
};
</script>

<style scoped>
.back{
  padding: 30px;
  cursor:pointer;
}
.el-select {
  margin-bottom: 0;
}

.address-table td {
  min-width: 12rem;
  padding: 0.5rem 0.5rem;
}

.address-table th,
td {
  padding: 0 0.5rem;
  border-bottom: 0.5px solid #dae8f6;
}

.radio-td {
  min-width: 3rem !important;
}

.address-action {
  min-width: 5rem !important;
}

.table-wrapper {
  margin-top: 0;
  overflow-x: auto;
}

.address-table input {
  margin-bottom: 0;
}
</style>
